import { CROPS } from "../data/crops";
import type { CropPlotState, CropStage } from "../types";

export function getCropStage(plot: CropPlotState, now = Date.now()): CropStage {
  if (!plot.cropId || !plot.plantedAt) return "empty";
  if (!plot.wateredAt || !plot.readyAt) return "dry";
  if (now >= plot.readyAt) return "ready";

  const total = Math.max(1, plot.readyAt - plot.wateredAt);
  const elapsed = Math.max(0, now - plot.wateredAt);
  const ratio = elapsed / total;
  if (ratio < 0.35) return "sprout";
  return "growing";
}

export function getGrowthProgress(plot: CropPlotState, now = Date.now()): number {
  if (!plot.cropId || !plot.wateredAt || !plot.readyAt) return 0;
  const total = Math.max(1, plot.readyAt - plot.wateredAt);
  return Math.min(1, Math.max(0, (now - plot.wateredAt) / total));
}

export function getRemainingMs(plot: CropPlotState, now = Date.now()): number {
  if (!plot.readyAt) return 0;
  return Math.max(0, plot.readyAt - now);
}

export function plantCrop(plot: CropPlotState, cropId: keyof typeof CROPS, now = Date.now()): CropPlotState {
  if (plot.cropId) throw new Error("แปลงนี้มีพืชอยู่แล้ว");
  return {
    ...plot,
    cropId,
    plantedAt: now,
    wateredAt: null,
    readyAt: null,
  };
}

export function waterCrop(plot: CropPlotState, now = Date.now()): CropPlotState {
  if (!plot.cropId) throw new Error("ต้องปลูกเมล็ดก่อนรดน้ำ");
  if (plot.wateredAt) throw new Error("แปลงนี้รดน้ำแล้ว");
  return {
    ...plot,
    wateredAt: now,
    readyAt: now + CROPS[plot.cropId].growMs,
  };
}

export function clearPlot(plot: CropPlotState): CropPlotState {
  return {
    ...plot,
    cropId: null,
    plantedAt: null,
    wateredAt: null,
    readyAt: null,
  };
}
